import { useCollaborativeDocumentContext } from '@spotify/confidence-editor-react';

import { isLockModeOn } from './lockMode';

export const useReportState = () => {
  const { collaborativeDocument, isPublished } =
    useCollaborativeDocumentContext();

  return {
    isLocked: isLockModeOn(collaborativeDocument.labels),
    isPublished,
  };
};
